<template>
  <div class="sitemap-container">
    <!-- モーダル画面 -->
    <div style="display: flex;">
      <!-- サイトマップルート編集モーダル -->
      <ModalSitemapRootEdit
        :isSitemapRootEditModalOpen="isSitemapRootEditModalOpen"
        :sitemapWaitList="sitemapWaitList"
        :sitemapRootList="sitemapRootList"
        @registSitemapWait="registSitemapWait"
        @deleteSitemapRootConfirm="deleteSitemapRootConfirm"
        @deleteSitemapWaitConfirm="deleteSitemapWaitConfirm"
        @closeRootEditModal="closeRootEditModal"
      />
      <!-- アラートダイアログ -->
      <ModalAlertDialog
        :isAlertDialogOpen="isAlertDialogOpen"
        :alertData="alertData"
        @alertResult="alertResult"
      />
    </div>
      <div class="header-sitemap">
        <p style="padding: 7px;"><b>ロボ：起動設定画面</b></p>
        <!-- サイトマップルート選択 -->
        <div class="select-box-form">
          <b-field>
            <div class="select-box-left">
              <p>ホームページのURL</p>
            </div>
            <div class="select-box-right">
              <!-- URL選択 -->
              <select class="select is-small" v-model ="selectSitemapRoot" style ="width: 100%; min-width: 200px;" :disabled="!sitemapRootList">
                <option v-for="(sitemapRoot, index) in sitemapRootList" :key="index" :value="sitemapRoot">
                  {{sitemapRoot.root_url}}
                </option>
              </select>
              <!-- サイトマップルート編集ボタン -->
              <button class="button is-primary is-small" @click="openRootEdit">
                <span class="mdi mdi-playlist-edit"/>
              </button>
            </div>
          </b-field>
        </div>
      </div>
      <!-- Body -->
      <div class="body-sitemap">
        <!-- サイトマップルート未登録時の表示 -->
        <div class="notfound-sitemap" v-if="!sitemapRootList.length > 0 && !isLoading" >
          <p><span class="mdi mdi-link-variant-off mdi-48px"></span></p>
          <p>URLの設定がされておりません。</p>
          <p>以下の項目にホームページのURLを記入し、</p>
          <p>「生成」ボタンを押下するとサイトマップが自動で生成されます。</p>
          <div class="create-box-form">
            <b-field style="margin-top: 50px; width: 60%;">
              <div class="create-box-left">
                <p>新規追加</p>
              </div>
              <div class="create-box-right">
                <input class="input is-small" placeholder="作成するサイトマップのURLを入力" v-model="createSitemapUrl"/>
                <button class="button is-primary is-small" @click="registSitemapWait(createSitemapUrl)" :disabled="!createSitemapUrl">
                  生成
                </button>
              </div>
            </b-field>
          </div>
          <div style="margin-top: 50px;" v-if="sitemapWaitList">
            <p>以下は作成待機中のサイトマップです。</p>
            <div v-for="(waitSitemap, idx) in sitemapWaitList" :key="idx">
              <p>{{waitSitemap.url}}</p>
            </div>
          </div>
        </div>
        <div class="editor-sitemap disp-scroll" v-else-if="!isCreateSitemap &&
          (sitemapRootList.length > 0 || sitemapRecruitListAll.length > 0 || sitemapCustomListAll.length > 0)">
          <!-- タブ -->
          <b-tabs type="is-boxed" v-model="tabIndex">
            <!-- ホームページタブ -->
            <b-tab-item label="ホームページ" v-if="selectSitemapRoot">
              <SitemapTable
                :pageType="'homepage'"
                @changeScnList="changeScnList"
                @addSitemapNode="addSitemapNode"
                @updateSitemap="updateSitemap"
                @alertConfirmDeleteSitemapNode="alertConfirmDeleteSitemapNode"
                @alertConfirmUnapplyRobo="alertConfirmUnapplyRobo"
                @dispErrorAlert="dispErrorAlert"
                @registSitemapWait="registSitemapWait"
                @getSitemapRoboList="getSitemapRoboList"
              />
            </b-tab-item>
            <!-- 求人ページタブ -->
            <b-tab-item label="求人ページ">
              <SitemapTable
                :pageType="'recruit'"
                @changeScnList="changeScnList"
                @addSitemapNode="addSitemapNode"
                @updateSitemap="updateSitemap"
                @alertConfirmDeleteSitemapNode="alertConfirmDeleteSitemapNode"
                @alertConfirmUnapplyRobo="alertConfirmUnapplyRobo"
                @dispErrorAlert="dispErrorAlert"
                @registSitemapWait="registSitemapWait"
                @getSitemapRoboList="getSitemapRoboList"
              />
            </b-tab-item>
            <!-- カスタムページタブ -->
            <b-tab-item label="カスタムページ">
              <SitemapTable
                :pageType="'custom'"
                @changeScnList="changeScnList"
                @addSitemapNode="addSitemapNode"
                @updateSitemap="updateSitemap"
                @alertConfirmDeleteSitemapNode="alertConfirmDeleteSitemapNode"
                @alertConfirmUnapplyRobo="alertConfirmUnapplyRobo"
                @dispErrorAlert="dispErrorAlert"
                @registSitemapWait="registSitemapWait"
                @getSitemapRoboList="getSitemapRoboList"
              />
            </b-tab-item>
          </b-tabs>
        </div>
        <!-- サイトマップルート新規追加時の表示 -->
        <div class="editor-sitemap disp-scroll" style="display: flex; justify-content:center; align-items:center;" v-else-if="isCreateSitemap">
          <div class="load-display">
            <p>リクエストを受け付けました。</p>
            <p>今しばらくお待ちください。</p>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapState }          from 'vuex'
import ModalSitemapRootEdit  from '@/components/organisms/users/sitemap/ModalSitemapRootEdit'
import SitemapTable          from '@/components2/Robo/screen/organisms/SitemapTable'
import ModalAlertDialog      from '@/components/organisms/common/ModalAlertDialog'

// 外部関数
import 
{
  /** URIチェック */
  isUri
} from '@/functions/common/checksFunc'

import {
  /** アラートダイアログ用定義 */
  ALERT_DEF,
} from '@/functions/common/alertFunc'

import {
  /** 全体的定義 */
  SITEMAP_OVERALL,
  /** 機能名定義 */
  SITEMAP_ALERT_FUNCTION,
  /** キーワード種別定義 */
  SITEMAP_ALERT_KEYWORD,
  /** 操作種別定義 */
  SITEMAP_ACTION_TYPE,
  /** ページ種別定義 */
  SITEMAP_PAGE_TYPE,
  /** タブインデックス定義 */
  SITEMAP_TAB_INDEX,
  /** コンテンツ種別定義 */
  SITEMAP_CONTENT_TYPE,
  /** ディスパッチ先定義 */
  SITEMAP_DISPATCH,
  /** エラーアラート表示 */
  errorAlert,
  /** 待機中サイトマップルート削除確認ダイアログ表示 */
  deleteSitemapWaitConfirm,
  /** サイトマップルート削除確認ダイアログ表示 */
  deleteSitemapRootConfirm 
} from '@/functions/users/sitemapFunc'

export default {
  name: 'Sitemap',
  componentName: 'Sitemap',
  components: {
    /** サイトマップ */
    SitemapTable,
    /** アラートダイアログ */
    ModalAlertDialog,
    /** サイトマップルート編集ダイアログ */
    ModalSitemapRootEdit
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('sitemap', ['firstLoadCount', 'selectedSitemapRoot',
                            'isCreateSitemap', 'isLoading', 'nowPages',
                            'sitemapWaitList', 'sitemapRootList',
                            'sitemapRecruitListAll', 'sitemapCustomListAll',
                            'isError', 'errorTitele', 'errorMessage']),
    /** タグ検索オートコンプリートリスト取得 */
    filteredTagList() {
      if (!this.searchTagList) {
        return []
      }
      // 入力された文字に一致するタグだけフィルタリング
      return this.searchTagList.filter((option) => {
        return option.name
          .toString()
          .toLowerCase()
          .indexOf(this.autocompleteWords.toLowerCase()) >= 0
      })
    },
    /** ページ種別取得 */
    getPageType () {
      let type = SITEMAP_PAGE_TYPE.RECRUIT_PAGE

      if (this.tabIndex === SITEMAP_TAB_INDEX.RECRUIT_PAGE) {
        // 求人ページ
        type = SITEMAP_PAGE_TYPE.RECRUIT_PAGE
      } else if (this.tabIndex === SITEMAP_TAB_INDEX.CUSTOM_PAGE) {
        // カスタムページ
        type = SITEMAP_PAGE_TYPE.CUSTOM_PAGE
      } else {
        // ホームページ
        type = SITEMAP_PAGE_TYPE.HOME_PAGE
      }
      return type
    }
  },
  data () {
    return {
      /** 初回読み込みフラグ */
      isInitLoad                : false,
      /** タブインデックス */
      tabIndex                  : SITEMAP_TAB_INDEX.RECRUIT_PAGE,
      /** アラートダイアログオープンフラグ */
      isAlertDialogOpen         : false,
      /** アラートダイアログデータ */
      alertData                 : {},
      /** コンテンツ種別 */
      contentType               : SITEMAP_CONTENT_TYPE.RECRUIT_PAGE,
      /** 新規作成サイトマップのURL */
      createSitemapUrl          : '',
      /** 求人ページ表示中(初期表示；求人ページ) */
      isRecruit                 : false,
      /** サイトマップルート編集モーダルフラグ */
      isSitemapRootEditModalOpen: false,
      /** 削除対象待機中サイトマップルート */
      deleteSitemapWait         : {},
      /** 削除対象サイトマップルート */
      deleteSitemapRoot         : {},
      /** 選択中のサイトマップ */
      selectSitemapRoot         : {},
      /** オートコンプリート用検索タグリスト */
      searchTagList             : [],
      /** タグ用オートコンプリートリスト */
      autocompleteWords         : '',
      /** オートコンプリートv-model保存用 */
      searchWords               : []
    }
  },
  mounted () {
    // 初期表示のサイトマップルートセット
    this.setSelectSitemap()
    this.$store.dispatch('sitemap/getSitemapRoboList')
  },
  watch: {
    /** オートコンプリート文字列迂回保存 */
    autocompleteWords () {
      // 直接b-autocompleteのv-modelにするとエラーになるので迂回して格納
      this.searchWords = this.autocompleteWords;
    },
    /** タブ切替 */
    tabIndex () {
      if (this.tabIndex === 1) {
        // 求人ページ
        this.isRecruit   = true
        this.contentType = SITEMAP_CONTENT_TYPE.RECRUIT_PAGE
      } else if (this.tabIndex === 2) {
        // カスタムページ
        this.isRecruit   = true
        this.contentType = SITEMAP_CONTENT_TYPE.CUSTOM_PAGE
      } else {
        // ホームページ
        this.isRecruit = false
        this.contentType = SITEMAP_CONTENT_TYPE.HOME_PAGE
      }
    },
    /** サイトマップルートリスト更新 */
    sitemapRootList () {
      // 選択中サイトマップルートセット
      this.setSelectSitemap()
    },
    /** 選択中サイトマップルート変更 */
    selectSitemapRoot () {
      // サイトマップルート選択
      this.$store.dispatch(SITEMAP_DISPATCH.SET_SELECT_SITEMAP, this.selectSitemapRoot)
    },
    selectedSitemapRoot () {
      // サイトマップルートを選択状態にする
      this.selectSitemapRoot = this.selectedSitemapRoot
    },
    /** エラー発生 */
    isError () {
      if (this.isError) {
        // エラーアラート表示
        this.dispErrorAlert(this.errorTitele, this.errorMessage)
      }
    }
  },
  methods: {
    //////////////////////////////////////////
    // 待機中サイトマップルート関連
    /** 待機中サイトマップルート削除確認アラート表示 */
    deleteSitemapWaitConfirm (deleteWait) {
      this.deleteSitemapWait = deleteWait
      this.alertData = deleteSitemapWaitConfirm (deleteWait.url)
      this.isAlertDialogOpen = true
    },
    //////////////////////////////////////////
    // サイトマップルート関連
    /** サイトマップルート編集モーダルオープン */
    openRootEdit () {
      this.isSitemapRootEditModalOpen = true
    },
    /** サイトマップルート編集モーダルクローズ */
    closeRootEditModal () {
      this.isSitemapRootEditModalOpen = false
    },
    /** 新規サイトマップルート登録 */
    registSitemapWait (createSitemapUrl) {
      if (!isUri(createSitemapUrl)) {
        // 不正URL
        this.dispErrorAlert('URL不正', '無効なURLです。')
      } else {
        // 最後の「/」削除
        for (let index = 0; index < createSitemapUrl.length; index++) {
          // 最後の「/」が複数個あった場合を考慮してなくなるまで探す
          const searchIndex = createSitemapUrl.lastIndexOf('/')
          if (searchIndex === (createSitemapUrl.length -1)) {
            // 「/」を削除
            createSitemapUrl = createSitemapUrl.slice(0, -1)
          } else {
            // 「/」がなくなったら終わり
            break
          }
        }
        // 新規サイトマップルート登録
        this.$store.dispatch(SITEMAP_DISPATCH.REGIST_SITEMAP_WAIT, {url: createSitemapUrl})
        this.createSitemapUrl = ''
      }
    },
    /** サイトマップルート削除確認アラート表示 */
    deleteSitemapRootConfirm (deleteRoot) {
      this.deleteSitemapRoot = deleteRoot
      this.alertData = deleteSitemapRootConfirm(deleteRoot.root_url)
      this.isAlertDialogOpen = true
    },
    //////////////////////////////////////////
    // サイトマップノード関連
    addSitemapNode (addNodePath) {
      if (addNodePath.charAt(0) !== '/') {
        addNodePath = '/' + addNodePath
      }
      const addNodeData = {
        sitemap_root_pk: this.selectedSitemapRoot.pk,
        add_node       : addNodePath
      }
      this.$store.dispatch(SITEMAP_DISPATCH.ADD_SITEMAP_NODE, addNodeData)
    },
    /** 対象サイトマップの更新(求人ページ、カスタムページ、ホームページ共通) */
    updateSitemap (updateData, isRecruit) {
      if (isRecruit) {
        const pageData = {
          pages       : this.nowPages,
          per_page    : SITEMAP_OVERALL.PER_PAGE,
          content_type: this.contentType
        }
        const sendData = {
          update_data: updateData,
          page_data  : pageData
        }
        // 求人ページおよびカスタムページ更新
        this.$store.dispatch(SITEMAP_DISPATCH.UPDATE_SITEMAP_RECRUIT, sendData)
      } else {
        // ホームページ更新
        const sendData = {
          update_data: updateData,
        }
        this.$store.dispatch(SITEMAP_DISPATCH.UPDATE_SITEMAP_NODE, sendData)
      }
    },
    /** サイトマップノード編集エラー */
    errorSitemapNodeEdit (title, message) {
      // エラーアラート表示
      this.dispErrorAlert(title, message)
    },
    /** サイトマップノード削除確認ダイアログオープン */
    alertConfirmDeleteSitemapNode (alertData, deleteNode) {
      this.deleteSitemapNode = deleteNode
      this.alertData         = alertData
      this.isAlertDialogOpen = true
    },
    //////////////////////////////////////////
    // ロボ適用関連
    /** ロボ適用解除確認アラート表示 */
    alertConfirmUnapplyRobo (alertData, target, unapplyRobo) {
      this.unapplyTargetSitemap = target
      this.unapplyRobo          = unapplyRobo
      this.alertData            = alertData
      this.isAlertDialogOpen    = true
    },
    //////////////////////////////////////////
    // 制御関連
    /** 選択中サイトマップ更新 */
    setSelectSitemap () {
      if (this.sitemapRootList.length > 0 && this.selectSitemapRoot) {
        if (!this.isInitLoad) {
          this.isInitLoad = true
          // 最初にあるサイトマップルートを選択
          this.selectSitemapRoot = this.sitemapRootList[0]
          this.$store.dispatch(SITEMAP_DISPATCH.SET_SELECT_SITEMAP, this.sitemapRootList[0])
        } else {
          // 初回以外は選択中のサイトマップと一致するデータをセットする
          for (const root of this.sitemapRootList) {
            if(root.sitemap_id === this.selectSitemapRoot.sitemap_id) {
              this.selectSitemapRoot = root
              this.$store.dispatch(SITEMAP_DISPATCH.SET_SELECT_SITEMAP, root)
              break
            }
          }
        }
      }
    },
    /** シナリオ編集画面に遷移 */
    changeScnList (scenarioname, robo) {
      this.$emit('changeScnList', scenarioname, robo)
    },
    /** エラーアラート表示 */
    dispErrorAlert (title, message) {
      this.alertData = errorAlert( SITEMAP_ALERT_FUNCTION.SITEMAP_MAIN, title, message)
      this.isAlertDialogOpen = true
    },
    /** アラートダイアログの結果処理 */
    alertResult (alertResultData) {
      if (alertResultData) {
        if (alertResultData.alertKeyFunction === SITEMAP_ALERT_FUNCTION.SITEMAP_MAIN) {
          // サイトマップメイン
          if (alertResultData.alertKeyWord === SITEMAP_ALERT_KEYWORD.ALERT ||
              alertResultData.alertKeyWord === SITEMAP_ALERT_KEYWORD.TOAST) {
            // アラートまたはトースト
            this.isAlertDialogOpen = false
          } else if (alertResultData.alertKeyWord === SITEMAP_ALERT_KEYWORD.DEL_SITEMAP_WAIT) {
            if (alertResultData.alertResultValue === ALERT_DEF.RESULT_YES) {
              // 待機中サイトマップルート削除実行
              const deleteSitemapWait = {
                sitemap_wait_pk: this.deleteSitemapWait.pk
              }
              this.$store.dispatch(SITEMAP_DISPATCH.DELETE_SITEMAP_WAIT, deleteSitemapWait)
            }
          } else if (alertResultData.alertKeyWord === SITEMAP_ALERT_KEYWORD.DEL_SITEMAP_ROOT) {
            if (alertResultData.alertResultValue === ALERT_DEF.RESULT_YES) {
              // サイトマップルート削除実行
              const deleteSitemapRoot = {
                sitemap_root_pk: this.deleteSitemapRoot.pk
              }
              this.$store.dispatch(SITEMAP_DISPATCH.DELETE_SITEMAP_ROOT, deleteSitemapRoot)
            }
          }
          if (this.isError) {
            this.$store.dispatch(SITEMAP_DISPATCH.RESET_ERROR)
          }
          this.isAlertDialogOpen = false
        } else if (alertResultData.alertKeyFunction === SITEMAP_ALERT_FUNCTION.SITEMAP_TABLE) {
          // サイトマップテーブル
          if (alertResultData.alertKeyWord === SITEMAP_ALERT_KEYWORD.ALERT ||
              alertResultData.alertKeyWord === SITEMAP_ALERT_KEYWORD.TOAST) {
            // アラートまたはトースト
            this.isAlertDialogOpen = false
          } else if (alertResultData.alertKeyWord === SITEMAP_ALERT_KEYWORD.ROBO_UNAPPLY) {
            // ロボ適用の解除
            if (alertResultData.alertResultValue === ALERT_DEF.RESULT_YES) {
              // ロボ適用解除実行
              if (this.unapplyTargetSitemap && this.unapplyRobo) {
                const updateList = [{
                  target: this.unapplyTargetSitemap,
                  robo  : [this.unapplyRobo]
                }]
                const updateData = {
                  update_list: updateList,
                  action     : SITEMAP_ACTION_TYPE.ROBO_UNAPPLY,
                  is_mini    : this.unapplyRobo.is_mini
                }
                this.updateSitemap(updateData, this.isRecruit)
              }
            } else {
              // ロボ適用解除キャンセル
              this.unapplyTargetSitemap = null
              this.unapplyRobo = null
            }
          } else if (alertResultData.alertKeyWord === SITEMAP_ALERT_KEYWORD.DEL_SITEMAP_NODE) {
            if (alertResultData.alertResultValue === ALERT_DEF.RESULT_YES) {
              // サイトマップノードの削除実行
              if (this.deleteSitemapNode) {
                const deleteNodeData = {
                  node_pk: this.deleteSitemapNode.pk
                }
                this.$store.dispatch(SITEMAP_DISPATCH.DELETE_SITEMAP_NODE, deleteNodeData)
              }
            } else {
                this.deleteSitemapNode = null
            }
          }
          if (this.isError) {
            this.$store.dispatch(SITEMAP_DISPATCH.RESET_ERROR)
          }
          // アラートダイアログを閉じる
          this.isAlertDialogOpen = false
        }
      }
    },
    getSitemapRoboList () {
      this.$emit('getSitemapRoboList')
    }
  }
}
</script>

<style scoped>
.sitemap-container {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.header-sitemap {
  padding-top: 15px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 35px;
  display: flex;
  justify-content: space-between;
  background: white;
  width: 100%;
  height: 10%;
}
.body-sitemap {
  width: 100%;
  height: 90%;
  display: flex;
}
.editor-sitemap {
  width: 100%;
  height: 100%;
  background: white;
}
.cells {
  border-bottom: solid thin #ccc;
  background: white;
}
.notfound-sitemap {
  width: 100%;
  height: 100%;
  background: white;
}
.svg {
  background-color: #f9f9f9;
}
.cell-class {
  padding: 0.5em !important;
}
.flex {
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-align-items: center;
    align-items: center;
}
.edit-modal {
  height: 300px;
  overflow: auto;
  width: 100%;
  border-radius: 5px;
  background: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}
.load-display {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  background: white;
  width: 100vw;
  height: calc(100vh - 100px);
  margin: -15px;
}
/* 初期ページ用 -- start -- */
.init-page {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(255, 255, 255, 0.5);
  z-index: 10000;
}
.select-box-form {
  width: 50%;
  justify-content: right;
  align-items: right;
}
.select-box-left {
  width: 160px;
  justify-content: left;
  align-items: left;
}
.select-box-right {
  width: calc(100% - 160px);
  font-size: 13px;
  padding-right: 48px;
  justify-content: flex-start;
  display: flex;
  align-items: right;
}
.create-box-form {
  width: 100%;
  justify-content: center;
  display: flex;
  align-items: center;
}
.create-box-left {
  width: 20%;
  justify-content: center;
  display: flex;
  align-items: center;
}
.create-box-right {
  width: 80%;
  font-size: 13px;
  padding-right: 48px;
  justify-content: flex-start;
  display: flex;
  align-items: center;
}

</style>


// WEBPACK FOOTER //
// src/views/DashBoard/ChatBot/Sitemap.vue